import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import * as $ from '../assets/js/jquery.js';
import { AuthService } from './shared/services/auth.service';
import {ParamService} from "./shared/services/param.service";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy{
    private adaFlag = false;
    private ClearAda = true;
    public hideUCALeftNav = false;
    private _routerSub;
    public isLanding = false;
    displayBanner: any;

    @HostListener('keyup', ['$event'])
    keyUp(event: KeyboardEvent) {
        if (!this.adaFlag && event.keyCode === 9) {
            // console.log('adding ada-fcous');
            // const elems = ['p', 'a', 'b', 's', 'span', 'div', 'td', 'img', 'input', 'select', 'button', 'h1', 'h2', 'h3'];
            // elems.forEach(e => $(e).addClass('ada-focus'));
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').addClass('ada-focus');
            this.adaFlag = true;
        }
    }

    @HostListener('window:click', ['$event'])
    onClick(event: MouseEvent) {
        if (this.adaFlag || this.ClearAda) {
            // console.log('removing ada-fcous');
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
            this.adaFlag = this.ClearAda = false;
        } else if ($(event.target).hasClass('ada-focus')) {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
            this.adaFlag = false;
        }
    }

    constructor(public router: Router, private authService: AuthService, private paramService: ParamService, private route: ActivatedRoute) {
        this.deleteCookie('_elevaate_session_id', '');
    }
    deleteCookie = (name, domain) => document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;

    ngOnInit() {
        const hideLeftNavRoutes = ['/game-details','/game-over','/prize-details'];
        this.displayBanner = this.paramService.displayBanner;
        this._routerSub = this.router.events.subscribe((events) => {
            if (events && events['url']) {
                const url = events['url'];
                if (url.indexOf('/game-details') >= 0 || url.indexOf('/game-over') >= 0 || url.indexOf('/prize-details') >= 0) {
                    this.isLanding = true;
                } else {
                    this.isLanding = false;
                }
                for (const route of hideLeftNavRoutes){
                    if (url.indexOf(route) >= 0 ) {
                        this.hideUCALeftNav = true;
                        break ;
                    } else {
                        this.hideUCALeftNav = false;
                    }
                }
                window.scrollTo(0, 0);
            }
        });
        this.getUserInfo();
    }

    navigateBack() {
        const currentUrl = this.router.url;
        if (currentUrl.includes('/game-details')) {
            this.router.navigate(['games/game-grid']);
        } else if (currentUrl.includes('/prize-details')) {
            const match = currentUrl.match(/\/prize-details\/([^\/]+)/);
            const id = match ? match[1] : null;
            if (id) {
                this.router.navigate(["games/game-details/" +id ]);
            } else {
                history.back();
            }
        } else {
            history.back();
        }
    }
   async getUserInfo() {
        await this.authService.getUserLogedInToken();
    }
    gameGrid(event:Event) {
        event.preventDefault();
        this.router.navigate(['games/game-grid']);
    }
    ngOnDestroy() {
        this._routerSub.unsubscribe();
    }
}
